import { useState } from 'react';
import axios from 'axios';

const API = 'https://weridesudan.com/api/admin';

export default function CreateAdmin({ token }: { token: string }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCreate = async () => {
    if (!name || !email || !password) { setError('All fields required'); return; }
    setLoading(true); setError(''); setMessage('');
    try {
      const res = await axios.post(`${API}/create-admin`, { name, email, password }, { headers: { Authorization: `Bearer ${token}` } });
      setMessage(res.data.message);
      setName(''); setEmail(''); setPassword('');
    } catch(err: any) {
      setError(err.response?.data?.message || 'Something went wrong');
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 480 }}>
      <h2>👤 Create New Admin</h2>
      <div style={{ background: '#fff', padding: 30, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
        <input value={name} onChange={e => setName(e.target.value)} placeholder="Full Name" style={{ width: '100%', padding: 12, marginBottom: 12, borderRadius: 8, border: '1px solid #ddd', fontSize: 14, boxSizing: 'border-box' as const }} />
        <input value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" type="email" style={{ width: '100%', padding: 12, marginBottom: 12, borderRadius: 8, border: '1px solid #ddd', fontSize: 14, boxSizing: 'border-box' as const }} />
        <input value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" type="password" style={{ width: '100%', padding: 12, marginBottom: 16, borderRadius: 8, border: '1px solid #ddd', fontSize: 14, boxSizing: 'border-box' as const }} />
        {error && <p style={{ color: 'red', marginBottom: 12 }}>{error}</p>}
        {message && <p style={{ color: 'green', marginBottom: 12 }}>{message}</p>}
        <button onClick={handleCreate} disabled={loading} style={{ width: '100%', padding: 14, background: '#1a73e8', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, cursor: 'pointer' }}>
          {loading ? 'Creating...' : 'Create Admin Account'}
        </button>
      </div>
    </div>
  );
}
